module.exports = __webpack_public_path__ + "img/17.333561f6.png";